import {
  Component, Output, EventEmitter, Input,
} from '@angular/core';
import { CourseFilter } from '../../courseFilter';

@Component({
  selector: 'app-course-course-types-filters',
  templateUrl: './course-course-types-filters.component.html',
  styleUrls: [ './course-course-types-filters.component.scss' ],
})
export class CourseCourseTypesFiltersComponent {
  @Input() mainFilter: CourseFilter;
  @Input() courseTypeList: any;
  @Output() updateMainFilter = new EventEmitter<object>();

  constructor() { }

  checkIncludesRequirement(courseType: any) {
    return !!this.mainFilter.courseTypes.find((ct: any) => ct.id === courseType.id);
  }

  updateCheckboxFilter(event: any, courseType: any): void {
    const isChecked = event?.target?.checked;

    if (isChecked) {
      this.mainFilter.courseTypes.push(courseType);
    } else {
      this.mainFilter.courseTypes = this.mainFilter.courseTypes.filter((ct: any) => ct.id !== courseType.id);
    }
  }

  selectAllCourseTypesFilter(event: any): void {
    if (event.target.checked) {
      this.mainFilter.courseTypes = this.courseTypeList;
    } else {
      this.mainFilter.courseTypes = [];
    }
  }

  clearCourseTypesFilter(): void {
    this.mainFilter.courseTypes = [];
  }

  getCourseTypeHelpText(courseType: any): string {
    // If the course type has a description, use it
    if (courseType?.description) {
      return courseType.description;
    }

    // If the course type has additional info, use it
    if (courseType?.additionalInfo) {
      return courseType.additionalInfo;
    }

    // If the course type has details, use them
    if (courseType?.details) {
      return courseType.details;
    }

    // If the course type has a category, provide context
    if (courseType?.category) {
      return `Show courses of type ${courseType.category}: ${courseType.courseType}`;
    }

    // If the course type has hours requirement, mention it
    if (courseType?.hoursRequired) {
      return `Show courses of type ${courseType.courseType} (${courseType.hoursRequired} hours required)`;
    }

    // If the course type has a color or identifier, mention it
    if (courseType?.color) {
      return `Show courses of type ${courseType.courseType} (${courseType.color})`;
    }

    // If the course type has usage count, mention it
    if (courseType?.usageCount) {
      return `Show courses of type ${courseType.courseType} (${courseType.usageCount} courses available)`;
    }

    // Default fallback with course type name
    return `Show courses that are of type ${courseType?.courseType}`;
  }

}
